import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { PrimaryButon } from "../../../../../components/common/button/PrimaryButon";
import { palette } from "../../../../../../theme/palette";
const theme = palette("light");
export const ConfirmationDialog = ({ open, handleClose, onConfirm, title, subTitle }) => {
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: "blur(3px)",
                backgroundColor: "rgba(74, 74, 74, 0.25)",
            },
        }, children: _jsxs(Box, { width: 717, sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "295px",
            }, children: [_jsx(Typography, { variant: "h4", color: "initial", mt: 2, children: title }), _jsx(Typography, { variant: "subtitle1", color: theme.black.dark, children: subTitle }), _jsxs(Box, { sx: {
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        mt: 4,
                    }, children: [_jsx(Box, { width: "250px", children: _jsx(PrimaryButon, { onClick: onConfirm, children: "Confirm" }) }), _jsx(Box, { width: "250px", children: _jsx(Button, { variant: "soft", fullWidth: true, size: "large", sx: { fontWeight: 500 }, color: "secondary", onClick: handleClose, children: "Cancel" }) })] })] }) }));
};
